<form [formGroup]="locationFormGroup">
  <div class="wrapper">
    <mat-form-field appearance="outline" class="">
      <mat-label>{{'location_settings.location_title' | translate}}</mat-label>
      <input #customLocation matInput formControlName="customLocation" [placeholder]="'location_settings.location_placeholder' | translate"
        [matAutocomplete]="auto">
      </mat-form-field>

      <mat-autocomplete #auto="matAutocomplete" [panelWidth]="'fit'" (optionSelected)="selectOption($event)" [displayWith]="displayFn.bind(this)">
        @for (option of availableOptions; track option) {
          <mat-option [value]="option.value">
            {{option.name}}
          </mat-option>
        }
      </mat-autocomplete>
    </div>
  </form>
